/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EnrollmentListItemCancelledReason = typeof EnrollmentListItemCancelledReason[keyof typeof EnrollmentListItemCancelledReason] | null;


export const EnrollmentListItemCancelledReason = {
  manual_user_cancel: 'manual_user_cancel',
  sequence_archived: 'sequence_archived',
  mailbox_disconnected: 'mailbox_disconnected',
  mailbox_changed: 'mailbox_changed',
  linkedin_account_disconnected: 'linkedin_account_disconnected',
  replied_interested: 'replied_interested',
  replied_not_interested: 'replied_not_interested',
  bounced: 'bounced',
  unsubscribed: 'unsubscribed',
  completed: 'completed',
  workflow_failure: 'workflow_failure',
  job_candidate_removed: 'job_candidate_removed',
  step_set_changed: 'step_set_changed',
  archived: 'archived',
} as const;
